<template>
  <!-- 报价记录 -->
  <div class="record">
    <!-- title -->
    <div class="home-header">
      <headers :params="hraderP"></headers>
      <van-tabs v-model="active" @click="listSelect">
        <van-tab v-for="tag in tagList" :title="tag" :key="tag.id"></van-tab>
      </van-tabs>
    </div>
    <!-- <div class="h12"></div> -->
    <div style="height:55px;background: #EFEFF4;" v-if="!isNativeApp"></div>
    <div style="height: 107px;background: #EFEFF4;" v-if="isNativeApp"></div>
     <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad"  v-show="list.length > 0">
      <div class="record-item-list" v-for="item in list">
        <div class="record-top" @click="detal(item)">
          <div class="record-item">
            <p class="title-1">{{item.projectName}}</p>
            <!-- <a class="pan dbj dbj-back">待报价</a> -->
            <a class="pan dbj dbj-back"  :class="`dbj-back`+item.status">{{item.status | statusList}}</a>
          </div>
          <div class="record-item">
            <p class="title-2">
              <span>业态：</span>
              <span>{{item.firstBuildingType}}</span>
              <!-- <span v-for="cell in item.firstBuildingType" :key="item.id">{{ cell.name }}</span> -->
            </p>
          </div>
        </div>
        <div class="record-item-bottom">
          <p>{{item.lastModifiedTime | lastModifiedTime}}</p>
          <a class="enter-price" v-if="item.status==0" @click="detal(item)">立即报价</a>
        </div>
      </div>
    </van-list>
    <router-link to="/index.html"><img src="../../assets/images/hjinexenter.png" alt="" class="to-index"></router-link>
    <noPaymentList v-show="list.length == 0"  @toListSelf="toListSelf"></noPaymentList>
    <!-- <div class="no-data">
      <img src="https://project-homedo.oss-cn-shanghai.aliyuncs.com/bd9f18a8-2069-4276-b6f2-9fe35dfba78e_nn-d.png" alt="">
      <div>暂无内容</div>
    </div> -->
  </div>
</template>

<script>
  import noPaymentList from '@/components/noPaymentList'
  import headers from '@/components/headerslf'
  import { getDesignList } from '@/api/designer/designer'
  import { statusList } from '@/filters/status'
  import {queryFirstType} from '@/api/demands/demand'
  export default {
    components: {
      headers,noPaymentList
    },
    data() {
      return {
        active: 0,
        loading: false,
        finished: false,
        tagList: ['全部', '待报价', '已报价', '已拒绝', '已过期'],
        list: [],
        hraderP: {
          title: '报价记录',
          lefticon: true
        },
        systemList:[],
        listQuery:{
          pageNum: 1,
          pageSize: 10,
          designerId:'',
          requireId:'',
          status:'',//报价状态 0-待报价 1-已报价 2-已拒绝 3-已过期
        },
        isNativeApp:false
      }
    },
    filters: {
      statusList,
      lastModifiedTime(e){
       const time= parseInt(e);
        var date = new Date(time);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var Y = date.getFullYear() + '-';
        var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
        var D = date.getDate() + ' ';
        var h = date.getHours() + ':';
        var m = date.getMinutes() + ':';
        var s = date.getSeconds();
        // that.giftList.insertTime = Y+M+D+h+m+s;
        // that.giftList.insertTime = Y+M+D;
        var insertTime = Y+M+D+h+m+s
        return  insertTime
      },
    },
    created() {
       this.isNativeApp = !(($HMD$.rNavigator && ($HMD$.rNavigator.toLowerCase() === 'ios' || $HMD$.rNavigator.toLowerCase() === 'android')))
       this.getData()
       this.getSystemType()
    },
    methods: {
      getSystemType () {
        queryFirstType()
          .then(result => {
            if (result.status === 200 && result.data && result.data.data) {
              this.systemList = result.data.data.requireTypeSysDataList
              console.log(result.data.data);
            }
          })
          .catch(err => {
            console.log(err)
            // ignore
          })
      },
      getData(){
        this.listQuery.pageNum = 0
        this.listQuery.pageSize = 10
        this.finished = false
        this.onLoad()
      },
      listSelect (index, title) {
        this.active = index
        this.list = []
       switch (title) {
        case '待报价':
           this.listQuery.status = 0
           break
        case '已报价':
            this.listQuery.status = 1
           break
        case '已拒绝':
            this.listQuery.status = 2
           break
        case '已过期':
            this.listQuery.status = 3
           break
        case '全部':
           this.listQuery.status = ''
           break
       }
       this.getData()
      },
      detal(item){
        // this.$router.push(`/designer/quotationDetail.html`)
        this.$router.push(`/designer/quotationDetail.html?id=${item.id}`)
      },
      toListSelf () {
        this.getData()
      },
      onLoad () {
         // 调用查询接口
         let self = this
         this.listQuery.pageNum++
         getDesignList(this.listQuery).then(result => {
            if (result && result.status === 200 && result.data  && result.data.data.list && result.data.data.list.length > 0) {
             self.list = self.list.concat(result.data.data.list)
             self.listQuery.pageNum = result.data.data.pageNum
             window.setTimeout(() => {
               self.loading = false
               if (self.list.length == result.data.data.total) {
                 self.finished = true
               }
             }, 1000)
             self.list.forEach(item => {
              const obj = this.systemList.find(cell=>+cell.id === +item.firstBuildingType) || {}
              item.firstBuildingType = obj.name
             })
           } else {
             self.loading = false
             self.finished = true
           }
         }).catch(() => {
           self.loading = false
           self.listQuery.total = 0
         })
      },
    }
  }
</script>

<style lang="scss">
  .record {
    .van-tab {
      font-size: 16px;
      color: rgba(0, 0, 0, 0.45);
    }

    .van-tab--active {
      color: #2F7BFF;
      font-weight: bold;
    }

    .van-tabs__line {
      height: 2px;
      background-color: #2F7BFF !important;
    }
  }
</style>
<style lang="scss" scoped>
  .record {
    .home-header{
      position: fixed;
      top: 0;
      width: 100%;
      z-index: 9;
    }
    .record-item-list {
      margin-bottom: 8px;
      background: #fff;

      .record-top {
        padding: 16px 13px 0 20px;

        .record-item {
          display: flex;
          justify-content: space-between;
          padding-bottom: 12px;

          .title-1 {
            font-size: 15px;
            color: rgba(0, 0, 0, 0.65);
            font-weight: 600;
          }

          .title-2 {
            font-size: 12px;
            color: #787878;
          }
          .pan{
            display: inline-block;
            width: 74px;
            height: 18px;
            line-height: 19px;
            font-size: 12px;
            background-size: 100% 100%;
            text-align: center;
          }
          .dbj{
            color: #FF6900;
          }
          .ybj{
            color: #14AE14;
          }
          .dbj-back3,.dbj-back20,.dbj-back0{
            color: #FF6900;
            background-image:url(../../assets/images/orange.png);
          }
          .dbj-back4{
            color: #2F7BFF;
            background-image:url(../../assets/images/blue.png);
          }
          .dbj-back1{
            color: #14AE14;
            background-image:url(../../assets/images/green.png);
          }
          .dbj-back2{
            color: #B5B5B5;
            background-image:url(../../assets/images/gray.png);
          }
          .ybj{
            color: #14AE14;
          }
          .ybj-back{
             background-image:url(../../assets/images/green.png);
          }
          .ygq{
            color: #B5B5B5
          }
          .ygq-back{
             background-image:url(../../assets/images/gray.png);
          }
          span {
            color: #FF0000;
          }
        }
      }

      .record-item-bottom {
        background: #F9FBFF;
        padding: 11px 13px 11px 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        p {
          font-size: 12px;
          font-weight: 600;
          color: #2F7BFF;
          height: 27px;
          line-height: 27px;
        }

        .enter-price {
          width: 79px;
          display: inline-block;
          height: 27px;
          line-height: 27px;
          text-align: center;
          font-size: 12px;
          font-weight: 600;
          color: #FFFFFF;
          background: linear-gradient(90deg, #FFA200 0%, #FF6900 100%, #FF6900 100%);
          border-radius: 13px;
        }
      }
    }
  }
  .to-index{
      width: 122px;
      position: fixed;
      right: 10px;
      bottom: 30px;
    }
  .h12 {
    height: 98px;
  }
</style>



// WEBPACK FOOTER //
// src/view/designer/quotation.vue